// extracted by mini-css-extract-plugin
export default {"best_deals":"deals_best_deals__KbY+q"};